import React from 'react';

const AnimatedBurgerMenu = () => {
  return (
    <svg
      className='ef-icon ef-header__icon -animated -animated-menu'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 32 32'
    >
      <g className='line1'>
        <rect
          className='rect1'
          y='9'
          width='32'
          height='3'
          rx='1'
          ry='1'
        />
      </g>
      <g className='line2'>
        <rect
          className='rect2'
          y='20'
          width='32'
          height='3'
          rx='1'
          ry='1'
        />
      </g>
    </svg>
  );
};

export {
  AnimatedBurgerMenu,
};
